import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AccessGate } from "@/components/AccessGate";
import { AdminPanel } from "@/components/AdminPanel";
import { Dashboard } from "@/components/Dashboard";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminPanel />} />
        <Route
          path="/*"
          element={
            <AccessGate>
              <Dashboard />
            </AccessGate>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
